import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setFilter } from "../../../../redux/stockBatch/fitlerStockBatchSlice";

const StockBatchFilter = () => {
  const filter = useSelector((state) => state.filterStockBatch);
  console.log(filter);
  const dispatch = useDispatch();
  const sortByData = [
    {
      label: "FIFO",
      value: "FIFO",
    },
    {
      label: "LIFO",
      value: "LIFO",
    },
    {
      label: "Expire Date",
      value: "expire-date",
    },
  ];

  const handleSortBy = (e) => {
    dispatch(
      setFilter({
        sortBy: e.target.value,
      }),
    );
  };
  return (
    <>
      <FormControl fullWidth style={{ maxWidth: 250, marginBottom: 20 }}>
        <InputLabel id="sort-by-label">Sort By</InputLabel>
        <Select
          labelId="sort-by-label"
          id="sort-by"
          value={filter.filterType.sortBy}
          label="Sort By"
          onChange={handleSortBy}
        >
          {sortByData?.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default StockBatchFilter;
